import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { SharedService } from '../../../../../shared/shared.service';
import { DriversService } from '../../drivers.service';
import { DriverArry } from './driver-array';
import { Location } from '@angular/common';
import notify from 'devextreme/ui/notify';
import { UsefulToolsService } from '../../../../../shared/other/usefultools.service';


@Component({
  selector: 'app-driver-edit',
  templateUrl: './driver-edit.component.html',
  styleUrls: ['./driver-edit.component.css']
})
export class DriverEditComponent implements OnInit {

  popupVisible = false;
  dataSource: any;
  sessionId = sessionStorage.getItem('com-session-id');
  driverId = sessionStorage.getItem('driver-id');

  constructor(
    public sharedService: SharedService,
    private httpClient: HttpClient,
    public drivers: DriversService,
    public datePipe: DatePipe,
    private location: Location,
    private usefultoolsservice: UsefulToolsService
  ) {}

  formatDateStringNoTime = this.sharedService.dateFormatStringNoTime;

  ngOnInit() {
    this.sharedService.loadingActive = true;
    if (this.drivers.newEdit === null || this.drivers.newEdit === undefined) {
      this.location.back();
    } else {
      if (this.drivers.newEdit === 1) {
        // tslint:disable-next-line:max-line-length
        this.dataSource = {NAME: '', SURNAME: '', CELLPHONE: '', EXTERNALFLAG: '', ACCESSPIN: '0', WORKINGAREA: '', STARTDATE: null, PHOTO: ''};
        this.sharedService.loadingActive = false;
      } else if (this.drivers.newEdit === 0) {
        // tslint:disable-next-line:max-line-length
        this.httpClient.get<any>(`${this.sharedService.URL}/dbDriver?SessionID=${this.sessionId}&ID=${this.driverId}&IncludePhoto=1`).subscribe(Response => {
          this.dataSource = Response.dbDriver_response.view[0];
          this.sharedService.loadingActive = false;
        });
      } else {
        this.sharedService.loadingActive = false;
        this.location.back();
      }
    }
  }

  async fileUploaded(pEvent) {
    this.dataSource.PHOTO = await this.usefultoolsservice.fileToBase64(pEvent.target.files[0]);
    this.dataSource.PHOTO = await this.usefultoolsservice.resizeImage(this.dataSource.PHOTO, 300);
  }

  onFormSubmit() {

    // validation
    if (this.dataSource.NAME === '' || this.dataSource.NAME === null) {
      this.usefultoolsservice.notify('error', `Required Name`);
      return;
    }
    if (this.dataSource.SURNAME === '' || this.dataSource.SURNAME === null) {
      this.usefultoolsservice.notify('error', `Required Surname`);
      return;
    }
    if (this.dataSource.CELLPHONE === '' || this.dataSource.CELLPHONE === null) {
      this.usefultoolsservice.notify('error', `Required Cellphone`);
      return;
    }
    if (isNaN(this.dataSource.CELLPHONE) === true) {
      this.usefultoolsservice.notify('error', `Cellphone can contain only numerical numbers`);
      return;
    }
    if (this.dataSource.ACCESSPIN === '' || this.dataSource.ACCESSPIN === null) {
      this.usefultoolsservice.notify('error', `Required Access PIN`);
      return;
    }
    if (isNaN(this.dataSource.ACCESSPIN) === true) {
      this.usefultoolsservice.notify('error', `Access PIN can contain only numerical numbers`);
      return;
    }
    if (this.dataSource.ACCESSPIN.length > 4) {
      this.usefultoolsservice.notify('error', `Access PIN can only be four digits long`);
      return;
    }
    if (this.dataSource.STARTDATE === '' || this.dataSource.STARTDATE === null) {
      this.usefultoolsservice.notify('error', `Required Start date`);
      return;
    }

    const postThis = {
      SessionID: sessionStorage.getItem('com-session-id'),
      Driver: [this.dataSource]
    };

    if (postThis.Driver[0].EXTERNALFLAG === false || postThis.Driver[0].EXTERNALFLAG === '' || postThis.Driver[0].EXTERNALFLAG == 0) {
      postThis.Driver[0].EXTERNALFLAG = 0;
    } else {
      postThis.Driver[0].EXTERNALFLAG = 1;
    }

    if (this.drivers.newEdit === 1) {
      this.httpClient.post<any>(`${this.sharedService.URL}/dbDriver`, postThis).subscribe(Response => {
        if (Response.dbDriver_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbDriver_response.ServiceResults[0].RESULTACTION === 'insert') {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successInsert);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbDriver_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    } else if (this.drivers.newEdit === 0) {
      this.httpClient.put<any>(`${this.sharedService.URL}/dbDriver`, postThis).subscribe(Response => {
        if (Response.dbDriver_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbDriver_response.ServiceResults[0].RESULTACTION === 'updateinsert') {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successUpdate);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbDriver_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    }
  }

  delete() {
    // tslint:disable-next-line:max-line-length
    this.httpClient.delete<any>(`${this.sharedService.URL}/dbDriver?SessionID=${this.sessionId}&ID=${this.driverId}`).subscribe(Response => {
      if (Response.dbDriver_response.ServiceResults[0].hasOwnProperty('ERRORDESCRIPTION')) {
        if (Response.dbDriver_response.ServiceResults[0].ERRORDESCRIPTION === 'Error occured Deleting the record 30] Entry Not Found [0]') {
          notify('Cannot delete this record. It is linked to other records in the database.', 'error', 5000);
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbDriver_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
        this.popupVisible = false;
      } else {
        this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successDelete);
        this.location.back();
      }
    });
  }

  toggle(data) {
    if (data === true) {
      this.popupVisible = true;
    } else {
      this.popupVisible = false;
    }
  }
}
